var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-modal-ex",
    {
      attrs: {
        active: _vm.isActive,
        "animation-in": _vm.animationIn,
        "animation-out": _vm.animationOut,
        "animation-duration": _vm.animationDuration,
        "can-cancel": false,
        "min-height": 55,
        "min-width": 30,
        "has-modal-card": "",
      },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
      },
    },
    [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [_vm._t("text-title")], 2),
      ]),
      _c("section", { staticClass: "modal-card-body" }, [
        _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "control" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.addToRemark,
                  expression: "addToRemark",
                },
              ],
              staticClass: "is-checkradio is-circle is-success",
              class: { "has-background-color": _vm.addToRemark },
              attrs: { id: "remark1", name: "remark1", type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.addToRemark)
                  ? _vm._i(_vm.addToRemark, null) > -1
                  : _vm.addToRemark,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.addToRemark,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.addToRemark = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.addToRemark = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.addToRemark = $$c
                  }
                },
              },
            }),
            _c("label", { attrs: { for: "remark1" } }, [_vm._v("Remark")]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.addToPrintedRemark,
                  expression: "addToPrintedRemark",
                },
              ],
              staticClass: "is-checkradio is-circle is-success",
              class: { "has-background-color": _vm.addToPrintedRemark },
              attrs: { id: "remark2", name: "remark2", type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.addToPrintedRemark)
                  ? _vm._i(_vm.addToPrintedRemark, null) > -1
                  : _vm.addToPrintedRemark,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.addToPrintedRemark,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.addToPrintedRemark = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.addToPrintedRemark = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.addToPrintedRemark = $$c
                  }
                },
              },
            }),
            _c("label", { attrs: { for: "remark2" } }, [
              _vm._v("Printed Remark"),
            ]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.addToJobNoteRemark,
                  expression: "addToJobNoteRemark",
                },
              ],
              staticClass: "is-checkradio is-circle is-success",
              class: { "has-background-color": _vm.addToJobNoteRemark },
              attrs: { id: "remark3", name: "remark3", type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.addToJobNoteRemark)
                  ? _vm._i(_vm.addToJobNoteRemark, null) > -1
                  : _vm.addToJobNoteRemark,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.addToJobNoteRemark,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.addToJobNoteRemark = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.addToJobNoteRemark = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.addToJobNoteRemark = $$c
                  }
                },
              },
            }),
            _c("label", { attrs: { for: "remark3" } }, [
              _vm._v("Job Note Remark"),
            ]),
          ]),
        ]),
        _vm.showRecurringRemark && _vm.recurringRemarks
          ? _c("div", { staticClass: "field" }, [
              _c(
                "div",
                { staticClass: "control" },
                [
                  _c(
                    "multiselect",
                    {
                      attrs: {
                        "track-by": "recurringRemarkId",
                        label: "remarkDescription",
                        placeholder: "Select a remark to add",
                        options: _vm.recurringRemarks,
                        searchable: true,
                        "allow-empty": true,
                      },
                      model: {
                        value: _vm.selectedRemark,
                        callback: function ($$v) {
                          _vm.selectedRemark = $$v
                        },
                        expression: "selectedRemark",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "has-text-danger",
                          attrs: { slot: "noResult" },
                          slot: "noResult",
                        },
                        [_vm._v("Remark not found.")]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm.showRemark
          ? _c("div", { staticClass: "field" }, [
              _c(
                "div",
                { staticClass: "is-flex" },
                [
                  _c("label", { staticClass: "label mb-2" }, [
                    _vm._v("Remark"),
                  ]),
                  _vm._t("remark-last-postfix"),
                ],
                2
              ),
              _c("div", { staticClass: "control" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.remark,
                      expression: "remark",
                    },
                    { name: "focus-inserted", rawName: "v-focus-inserted" },
                  ],
                  staticClass: "textarea",
                  attrs: { placeholder: "Add remark here" },
                  domProps: { value: _vm.remark },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.remark = $event.target.value
                    },
                  },
                }),
              ]),
            ])
          : _vm._e(),
        _vm.showPrintedRemark
          ? _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Printed Remark")]),
              _c("div", { staticClass: "control" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.printedRemark,
                      expression: "printedRemark",
                    },
                    {
                      name: "focus-inserted",
                      rawName: "v-focus-inserted",
                      value: { focus: !_vm.showRemark },
                      expression: "{ focus: !showRemark }",
                    },
                  ],
                  staticClass: "textarea",
                  attrs: { placeholder: "Add printed remark here" },
                  domProps: { value: _vm.printedRemark },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.printedRemark = $event.target.value
                    },
                  },
                }),
              ]),
            ])
          : _vm._e(),
        _vm.showJobNoteRemark
          ? _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("Job Note Remark"),
              ]),
              _c("div", { staticClass: "control" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.jobNoteRemark,
                      expression: "jobNoteRemark",
                    },
                    {
                      name: "focus-inserted",
                      rawName: "v-focus-inserted",
                      value: { focus: !_vm.showRemark },
                      expression: "{ focus: !showRemark }",
                    },
                  ],
                  staticClass: "textarea",
                  attrs: { placeholder: "Add job note remark here" },
                  domProps: { value: _vm.jobNoteRemark },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.jobNoteRemark = $event.target.value
                    },
                  },
                }),
              ]),
            ])
          : _vm._e(),
      ]),
      _c(
        "footer",
        {
          staticClass: "modal-card-foot",
          style: `justify-content: flex-${_vm.buttonLocation}`,
        },
        [
          _c(
            "button",
            {
              staticClass: "button is-primary tooltip is-tooltip-topright",
              attrs: { "data-tooltip": "Add remark or printed remark" },
              on: {
                click: function ($event) {
                  return _vm.add()
                },
              },
            },
            [_vm._v("Add Remark")]
          ),
          _c(
            "button",
            {
              staticClass: "button tooltip is-tooltip-topright",
              attrs: { "data-tooltip": "Close & don't add" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v("Close")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }